<script setup lang="ts">
import { computed } from 'vue'
import SiteEditableText from '../../SiteEditableText.vue'
import SiteLink from '../../SiteLink.vue'
import type { FooterBlock } from '../../types'

const props = defineProps<{ block: FooterBlock }>()
const brandLink = computed(() => props.block.content.brandLink ?? {
  label: props.block.content.businessName,
  destination: { type: 'page' as const, path: '/' },
})
const allLinks = computed(() => props.block.content.columns.flatMap((column) => column.links))
</script>

<template>
  <footer :id="block.settings.anchorId" class="site:border-t site:border-(--site-color-border) site:bg-(--site-color-surface) site:py-12 site:text-center site:@min-[40rem]:py-16">
    <div class="site-site-container">
      <SiteLink :link="brandLink" class="site-heading site:text-2xl site:font-bold">{{ block.content.brandLink?.label ?? block.content.businessName }}</SiteLink>
      <SiteEditableText v-if="block.content.description" v-model="block.content.description" as="p" class="site:mx-auto site:mt-4 site:max-w-xl site:leading-7 site:text-(--site-color-muted-text)" />
      <nav aria-label="Footer navigation" class="site:mt-7 site:flex site:flex-wrap site:justify-center site:gap-x-7 site:gap-y-3">
        <SiteLink v-for="(link, index) in allLinks" :key="`${link.label}-${index}`" :link="link" class="site:text-sm site:font-semibold">{{ link.label }}</SiteLink>
      </nav>
      <div v-if="block.content.socialLinks?.length" class="site:mt-6 site:flex site:flex-wrap site:justify-center site:gap-5">
        <SiteLink v-for="(link, index) in block.content.socialLinks" :key="`${link.label}-${index}`" :link="link" class="site:text-sm site:text-(--site-color-primary)">{{ link.label }}</SiteLink>
      </div>
      <SiteEditableText v-model="block.content.copyright" as="p" class="site:mt-8 site:text-sm site:text-(--site-color-muted-text)" />
    </div>
  </footer>
</template>
